<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { emailErrors } from 'src/plugins/validations'
// import ClassVerified from 'src/components/Attend/ClassVerified'
import { required, email, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'
import { passwordErrors, confirmPasswordErrors } from 'src/plugins/validations'

export default {
  name: 'ForgotPassword',
  components: {
  },
  validations () {
    return {
      changePasswordForm: {
        password: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(20)
        },
        confirmPassword: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(20),
          sameAs: sameAs("password")
        }
      }
    }
  },
  computed: {
    ...mapState('auth', {
      forgotPasswordForm: s => s.forgotPasswordForm,
      changePasswordForm: s => s.changePasswordForm
    }),
    passwordErrors () { return passwordErrors(this.validation.changePasswordForm) },
    confirmPasswordErrors () { return confirmPasswordErrors(this.validation.changePasswordForm) },
  },
  methods: {
    ...mapActions('auth', [
      'submitForgotPasswordForm',
      'submitResetPasswordForm'
    ]),
    ...mapMutations('auth', [
      'updateForgotPasswordForm',
      'updateChangePasswordForm'
    ]),
    async forgotPasswordHandler() {
      const response = await this.submitForgotPasswordForm(this.$route.query.token)
      console.log('response', response)
      if(response.success) this.$router.push('/login')
    },
    async resetPasswordHandler() {
      const response = await this.submitResetPasswordForm(this.$route.query.token)
      if(response.success) this.$router.push('/login')
    },
    goToLogin(){
      this.$router.push('/login')
    }
  }
}

</script>

<template>
  <q-page class="row">
    <div id="forgot-password-left" class="col-lg-5 col-md-6 col-sm-12 relative-position row items-center">
      <q-card-main class="content-center col-12" v-if="!$route.query.token">
        <form v-on:submit.prevent="">
          <h5 class="q-pa-md">Forgot Password</h5>
          <q-field class="q-pa-md">
            <q-input 
              name=""
              autofocus
              :value="forgotPasswordForm.email"
              clearable
              float-label="Email"
              :before="[{ icon: 'email' }]"
              @input="val => updateForgotPasswordForm({field: 'email', value: val})"/>
          </q-field>
          <div class="text-right">
            <q-field class="q-pa-md">
              <q-btn label="Send Reset Email" color="primary" @click="forgotPasswordHandler()"/>
            </q-field>
          </div>
        </form>
        <q-field class="outline col-12">
            <span class="text-bold">OR LOG-IN</span>
            <div class="float-right">
              <q-btn size="sm" label="Login" @click="goToLogin()" color="secondary" outline />
            </div>
        </q-field>        
      </q-card-main>
      <q-card-main class="content-center col-12" v-if="$route.query.token">
        <form v-on:submit.prevent="">
          <h5 class="q-pa-md">Change Password</h5>
          <q-field class="q-pa-sm"
            :error="$v.changePasswordForm.password.$error"
            error-label="Length must be between 6 and 20 characters">
            <q-input
              float-label="New Password"
              type="password"
              :before="[{ icon: 'lock' }]"
              :value="changePasswordForm.password"
              @keyup.stop="updateChangePasswordForm({field: 'password', value: $event.target.value})"
              @input="$v.changePasswordForm.password.$touch()"
              @blur="$v.changePasswordForm.password.$touch()"
              required>
            </q-input>
          </q-field>
          <q-field class="q-pa-sm"
            :error="$v.changePasswordForm.confirmPassword.$error"
            error-label="Must match set password">
            <q-input
              float-label="Confirm Password"
              type="password"
              :before="[{ icon: 'lock' }]"
              :value="changePasswordForm.confirmPassword"
              @keyup.stop="updateChangePasswordForm({field: 'confirmPassword', value: $event.target.value})"
              @input="$v.changePasswordForm.confirmPassword.$touch()"
              @blur="$v.changePasswordForm.confirmPassword.$touch()"
              required>
            </q-input>
          </q-field>
          <div class="text-right">
            <q-field class="q-pa-md">
              <q-btn label="Change Password" color="primary" @click="resetPasswordHandler()"/>
            </q-field>
          </div>
        </form>
        <q-field class="outline col-12">
            <span class="text-bold">OR LOG-IN</span>
            <div class="float-right">
              <q-btn size="sm" label="Login" @click="goToLogin()" color="secondary" outline />
            </div>
        </q-field>        
      </q-card-main>
      <!-- <class-verified v-if="currentClass !== null || signupComplete" /> -->
    </div>
    <div id="forgot-password-picture" class="col-lg-7 col-md-6 relative-position mobile-hide"></div>
  </q-page>
</template>

<style scoped>
  #forgot-password-left{
    border-top:5px solid #4d83ff;
    box-shadow: 0 0 95px #000000ab;
    position: relative;
    z-index: 1;
    padding:0 7%;
    background-image:url('../assets/img/login-left-bg.png');
    background-position:center bottom;
    background-repeat:no-repeat;
    background-color:#fff;
  }
  #forgot-password-picture{
    background-size:cover;
    background-image:url('../assets/img/forgotpassword.jpg');
    background-position:center;
  }
  .q-btn.bg-primary{
    font-size: 15px !important;
    padding: 15px 51px;
    font-weight: 600;
    letter-spacing: 1px;
  }
  .outline{
    border:1px solid #ccc;
    border-radius:2px;
    margin:50px 15px 0;
    padding: 20px 30px;
  }
  .outline .text-bold{
    font-size:13px;
    vertical-align:middle;
    line-height: 25px;
  }
  .dotted-underline{
    border-bottom:1px solid #4d83ff;
    text-decoration: none;
    margin-top:4px;
    display:inline-block;
    color:#000;
    font-size:13px;
  }
</style>
